import styled from 'styled-components';

export const IconMuiV4 = styled.div`
  font-family: 'Material Icons', sans-serif;
  font-weight: 700;
  font-size: 20px;
`;
